// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submitBtn {
  color: #000000 !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  letter-spacing: normal !important;
  text-align: center !important;
  background: rgba(30, 229, 118, 1) !important;
  padding: 16px !important;
  border-radius: 100px !important;
  border: none !important;
  cursor: pointer !important;
  margin-top: 0;
}

:root {
  --accent-green: rgba(30, 229, 118, 1); /* same as submitBtn */
  --text-dark: #000000;
  --table-bg: #ffffff;
  --table-header-bg: #046A38;
  --table-header-border: rgba(30, 229, 118, 0.30);
  --table-row-hover: rgba(30, 229, 118, 0.08);
  --table-border: #e9ecef; /* close to Bootstrap's border color */
}

.table-theme {
  font-family: "DM Sans", sans-serif;
  color: var(--text-dark);
}

.table-theme .table-card {
  background: var(--table-bg);
  border: 1px solid var(--table-border);
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.06);
}

.table-theme .table {
  margin: 0;
  border-collapse: separate;       
  border-spacing: 0;
}

.table-theme .table thead tr:first-child th:first-child {
  border-top-left-radius: 16px;
}
.table-theme .table thead tr:first-child th:last-child {
  border-top-right-radius: 16px;
}
.table-theme .table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 16px;
}
.table-theme .table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 16px;
}

.table-theme .table thead th {
  background: var(--table-header-bg);
  border-bottom: 2px solid var(--table-header-border);
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.2px;
  text-transform: none;
}

.table-theme .table tbody td,
.table-theme .table thead th {
  padding: 8px 16px; /* visually aligned with your button’s comfort spacing */
}

.table-theme .table tbody tr:hover {
  background: var(--table-row-hover);
}

.table-theme .table tbody tr + tr td {
  border-top: 1px solid var(--table-border);
}

.table-theme .table tbody td.id-col {
  color: var(--text-dark);
  font-weight: 500;
}

.table-theme .badge-accent {
  display: inline-block;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: #0f7a4d; /* readable on light background */
  background: rgba(30, 229, 118, 0.18);
  border: 1px solid rgba(30, 229, 118, 0.35);
}

.table-theme .btn-outline-accent {
  color: var(--text-dark);
  border-radius: 100px;
  border: 1px solid rgba(0,0,0,0.12);
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  background: #fff;
}
.table-theme .btn-outline-accent:hover {
  border-color: rgba(30, 229, 118, 0.8);
  color: #0f7a4d;
  background: rgba(30, 229, 118, 0.08);
}

.table-theme .btn-accent {
  color: var(--text-dark) !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  text-align: center !important;
  background: var(--accent-green) !important;
  padding: 10px 18px;                
  border-radius: 100px !important;
  border: none !important;
  cursor: pointer !important;
}

@media (max-width: 576px) {
  .table-theme .table thead th,
  .table-theme .table tbody td {
    padding: 12px 12px;
    font-size: 13px;
  }
  .table-theme .table thead th:last-child,
  .table-theme .table tbody td:last-child {
    white-space: nowrap;
  }
}

/**Pagination **/
.pagination {
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  /* padding-bottom: 60px; */
}

.page-btn {
    border: 1px solid #222;
    padding: 6px 12px;
    border-radius: 50%;
    cursor: pointer;
    background-color: #fff;
    color: #222222;
    transition: all .2s ease;
    height: 44px;
    width: 44px;
    font-family: var(--INTER-FONT);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-top: inherit;
}

.page-btn.active {
  background-color: #222;
  color: white;
  border-color: #222;
}

.next-btn {
  font-weight: 700;
  font-size: 16px;
  padding: 6px 10px;
  border: none;
}
/**Pagination **/

/**Common add/edit modal css**/

.modal {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: 100px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}
div.userDetailsModal {
  padding: 0 !important;
  z-index: 9999;
}
/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
}

body.modal-open {
  padding: 0 !important;
}
.lead-form .form-label {
  margin: 16px 0 0 0;
}

.lead-form label {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: normal;
  text-align: left;
  color: rgba(102, 102, 102, 1);
}

.lead-form input[type="text"],
.lead-form input[type="email"],
.lead-form input[type="number"] {
  border-left: none;
  border-right: none;
  outline: none;
  border-radius: 0;
  border-top: none;
  padding: 5px 0;
  box-shadow: unset;
}

.passwordInputs {
  border-bottom: 1px solid #8C8C8C !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
  border-radius: 0 !important;
}


.branchSelect {
  min-height: 35px ;
  cursor: pointer;
}

.list-group-item {
  padding: 4px 10px !important;
}
.userDetailsModal .modal-body p:nth-child(2) {
  font-family: "Inter", sans-serif;
  font-size: 12px !important;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: normal;
  color: #000000;
}

.userDetailsModal .modal-body p:nth-child(1) span {
  font-family: "Inter", sans-serif;
  letter-spacing: normal;
  font-size: 12px;
  color: #666;
  font-weight: 400;
  line-height: 18px
}

.userDetailsModal form.userDetailsModal .row.mt-4:has(.col-md-1) {
  margin-top: 16px !important;
  align-items: center !important;
}

.userDetailsModal label {
  font-family: "Inter", sans-serif !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: normal;
  text-align: left;
  color: #222222 !important;
  display: inline-block;
}

.userDetailsModal .form-control {
  padding: 0 !important;
  border-bottom-color: #8C8C8C;
}

#editUserModal .submitBtn:focus {
    outline: 2px solid #222 !important;
    outline-offset: 0px;
    background-color: #00b140 !important;
}
#addUserModal .submitBtn:focus {
    outline: 2px solid #222 !important;
    outline-offset: 0px;
    background-color: #00b140 !important;
}
#loading-image{
  color: #000000;
}

.lead-form button {
  color: #000000 !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  letter-spacing: normal !important;
  text-align: center !important;
  /* background: rgba(30, 229, 118, 1) !important; */
  padding: 16px 35%;
  border-radius: 100px !important;
  border: none !important;
  cursor: pointer !important;
  margin-top: 0;
}

.userDetailsModal .modal-body p span {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 19.6px;
  color: #414141;
  font-weight: 400;
  text-align: left;
  letter-spacing: normal;
}

.userDetailsModal .btn-close {
  position: absolute;
  right: 32px;
  top: 32px;
  width: 35px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  cursor: pointer;
  background: none;
  opacity: 1;
  border: 0;
}
.userDetailsModal .btn-close:focus,
.userDetailsModal .btn-close:focus-visible {
   outline: 2px solid black;
    outline-offset: 2px;
}

.userDetailsModal .btn-close:before,
.userDetailsModal .btn-close:after {
  position: absolute;
  top: 0;
  content: ' ';
  height: 24px;
  width: 3px;
  background-color: #333;
  display: inline-block;
}

.userDetailsModal .btn-close:before {
  transform: rotate(45deg);
}

.userDetailsModal .btn-close:after {
  transform: rotate(-45deg);
}

.userDetailsModal .modal-header {
  border-bottom: 0;
  padding: 54px 56px 0 56px;
  padding: 0;
}

.userDetailsModal .modal-body {
  max-height: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding-left: 5px;
}

/* MultiSelect Dropdown Styles */
.tg-multiselect {
  position: relative !important;
  z-index: 1000 !important;
}

.userDetailsModal .tg-multiselect {
  z-index: 1001 !important;
}

.tg-multiselect-panel {
  z-index: 10000 !important;
  max-width: 90vw !important;
}

/* Ensure modal body doesn't clip the dropdown */
.userDetailsModal .modal-dialog {
  overflow: visible !important;
}

.userDetailsModal .modal-content {
  overflow: visible !important;
}

.userDetailsModal .modal-body {
  overflow: visible !important;
  position: relative;
  z-index: auto;
}

/* Responsive styles for MultiSelect */
@media (max-width: 576px) {
  .tg-multiselect-panel {
    max-width: 85vw !important;
    max-height: 250px !important;
  }
  
  .userDetailsModal .col-md-6 {
    position: relative;
    z-index: 1001;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  .tg-multiselect-panel {
    max-width: 80vw !important;
    max-height: 300px !important;
  }
}

@media (min-width: 769px) {
  .tg-multiselect-panel {
    max-width: auto !important;
    max-height: 400px !important;
  }
}
.lead-form input[type="text"],
.lead-form input[type="email"],
.lead-form input[type="number"] {
  min-height: 35px !important;
}

/* width */
.userDetailsModal::-webkit-scrollbar {
  width: 2px;
}

/* Track */
.userDetailsModal ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.userDetailsModal ::-webkit-scrollbar-thumb {
  background: #414141;
}

/* Handle on hover */
.userDetailsModal ::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.userDetailsModal .modal-title {
  font-family: "DM Sans",sans-serif;
  font-size: 48px;
  font-weight: 500;
  line-height: 52.8px;
  letter-spacing: normal;
  text-align: left;
  color: #222222;
}

.userDetailsModal span#myModalClose {
  border-radius: 0;
  padding: 0 !important;
  margin-right: 10px !important;
}

.userDetailsModal.show{
  display: block !important;
}

/* width */
.userDetailsModal ::-webkit-scrollbar {
  width: 2px;
}

/* Track */
.userDetailsModal ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.userDetailsModal ::-webkit-scrollbar-thumb {
  background: #414141;
}

/* Handle on hover */
.userDetailsModal ::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.modal {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: unset;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
}

.modal-backdrop {
  display: none;
}

.modal,
.modal-open {
  background: rgba(0, 0, 0, .5);
  overflow: hidden
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  outline: 0
}

.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 8px !important;
  pointer-events: none
}

.modal.fade .modal-dialog {
  transition: transform .3s ease-out;
  transform: translateY(-25%)
}

.modal.show .modal-dialog {
  transform: translate(0)
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 16px)
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(28, 28, 28, .2);
  border-radius: 16px;
  outline: 0
}

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #1c1c1c
}

.modal-backdrop.fade {
  opacity: 0
}

.modal-backdrop.show {
  opacity: .5
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #e9ecef;
  border-top-left-radius: 0;
  border-top-right-radius: 0
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.55
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 16px
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px;
  border-top: 1px solid #e9ecef
}

.modal-footer>:not(:first-child) {
  margin-left: .25rem
}

.modal-footer>:not(:last-child) {
  margin-right: .25rem
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll
}

.modal-content .modal-body_title {
  color: #00703c;
  font-size: 36px
}

.modal-header {
  border-bottom: none
}

.modal-body {
  padding: 44px 16px 100px
}

.modal-section-padding {
  padding-right: 17px
}
.userDetailsModal .submitBtn{
  height: auto;
}

.userDetailsModal .submitBtn:hover, #editUserModal .submitBtn:focus {
  background-color: #00B140 !important;
}
.userDetailsModal .modal-content{
  padding: 64px 56px 56px;
  border-radius: 16px;
}

.invalid-feedback.show {
  display: block !important;
}

@media screen and (max-width: 600px) {
  .lead-form button#submit_lead_data {
    margin-top: 4px !important;
    padding: 13px 0px;
    width: 100%;
  }
}

@media (min-width:576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 28px auto !important;
    padding: 0;
  }

  .modal-dialog-centered {
    min-height: calc(100% - 56px)
  }

  .modal-sm {
    max-width: 300px
  }
}

@media (max-width: 767px) {

  .userDetailsModal .modal-title {
    font-size: 36px !important;
    line-height: 38.52px !important;
  }
  .userDetailsModal .modal-content .modal-header{
    padding: 24px 16px 16px;
  }
  .userDetailsModal .modal-body {
    padding: 0 16px 16px;
  }
  .userDetailsModal .call-now-mob.d-block {
    background: #000;
    color: #fff !important;
    width: 100%;
    display: block !important;
    padding: 16px 0;
    border-radius: 40px;
    text-align: center;
    text-decoration: none;
    margin-bottom: 26px;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    text-transform: capitalize;
    font-family: "DM Sans", sans-serif;
    letter-spacing: normal;
  }
  .userDetailsModal .submitBtn {
    max-width: 100%;
    width: 100%;
  }

  .userDetailsModal .modal-content{
    padding: 64px 16px 32px;
  }
}

@media (min-width:720px) and (max-width:766px) {
  button#submit_lead_data {
    width: 100%;
  }
}

@media screen and (min-width: 992px) {
  .userDetailsModal .modal-dialog {
    max-width: 800px !important;
  }
}

@media (min-width:720px) and (max-width:766px) {
  .userDetailsModal .modal-dialog {
    max-width: 500px !important;
  }
}

@media (min-width:768px) and (max-width:991px) {
  .userDetailsModal .modal-dialog {
    max-width: 700px;
  }

  .userDetailsModal .show {
    display: block !important;
  }
}


@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .userDetailsModal .modal-content {
    width: 100% !important;
  }

  .userDetailsModal .modal-title {
    font-size: 48px !important;
  }
}

.invalid-feedback{
  color: #D22B2B !important;
  width: 100%;
  margin-top: 4px !important;
  font-size: 12px !important;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  line-height: 18px;
}
.userDetailsModal .btn-close:focus{
  outline: 2px solid transparent !important;
  box-shadow: none !important;
}

/**Common add/edit modal css**/

/**Success modal**/
#leadSuccessModal {
    background: rgba(0, 0, 0, .5);
}

#leadSuccessModal.show {
    display: flex !important;
    align-items: center;
    justify-content: center;
    z-index: 10000;
}

#leadSuccessModal .modal-dialog {
    width: 100%;
    max-width: 800px;
    margin: 0 16px !important;
}

#leadSuccessModal .modal-dialog button.btn-close {
    align-self: flex-start;
    position: absolute;
    right: 24px;
    top: 24px;
    margin: 0;
    padding: 11px;
    opacity: 1;
}

#leadSuccessModal .modal-dialog .modal-content{
    border: none;
    border-radius: 16px;
}

#leadSuccessModal .modal-body .donexx p {
    font-family: "Inter",sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
}


/* css for lead and success modal */


#leadSuccessModal .modal-header {
    padding: 24px 56px 0 40px !important;
    padding: 0 !important;
}
  
#leadSuccessModal .modal-body {
    padding: 24px 30px 48px 40px;
    padding: 0;
}
  
#leadSuccessModal .modal-dialog.modal-lg {
    height: 100%;
    align-items: center;
    display: flex;
    margin-top: 0;
    padding: 0;
}

  #leadSuccessModal .btn-close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
    display: block;
    cursor: pointer;
    background: transparent;
    border: none;
    padding: 0;
  }
  
  #leadSuccessModal .btn-close:before,
  #leadSuccessModal .btn-close:after {
    position: absolute;
    content: ' ';
    height: 20px;
    width: 2px;
    background-color: #333;
    top: 0;
  }
  
  #leadSuccessModal .btn-close:before {
    transform: rotate(45deg);
  }
  
  #leadSuccessModal .btn-close:after {
    transform: rotate(-45deg);
  }

    #leadSuccessModal .modal-title {
    font-family: "DM Sans",sans-serif;
    font-size: 48px;
    font-weight: 500;
    line-height: 52.8px;
    letter-spacing: normal;
    text-align: left;
    color: #222222;
  }
  #leadSuccessModal .modal-body p {
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    color: #414141;
    margin-bottom: 24px;
    margin-top: 16px;
  }
  
  #leadSuccessModal form.success-lead-form {
    /* margin-top: 81px; */
  }
  
  #leadSuccessModal #btnTrigger{
    display: none;
  }
  #leadSuccessModal .modal-content{
    border-radius: 16px;
    padding: 64px 56px 56px;
    border: none;
  }
  
  #leadSuccessModal .modal-body {
    max-height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    margin-right: 5px;
    /* padding: 16px 56px 40px; */
  }

  #leadSuccessModal .modal-title.donex {
    font-family: "DM Sans",sans-serif;
    font-size: 48px;
    font-weight: 500;
    line-height: 52.8px;
    letter-spacing: normal;
    text-align: left;
    /* margin-top:40px; */
}

#leadSuccessModal .modal-header {
    border-bottom: none;
    padding: 24px 56px 0;
}

#btnDone {
    background-color: #1EE576;
    color: #000000;
    width: 214px;
    height: 48px !important;
    border-radius: 40px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
}
#leadForm .submitBtn:hover, #leadSuccessForm #btnDone:hover {
    background-color: #19C063;
}

#leadForm .submitBtn:focus, #leadSuccessForm #btnDone:focus {
    background-color: #19C063 !important;
    outline: none;
}

#leadForm .submitBtn:disabled, #leadSuccessForm #btnDone:disabled {
    background-color: #CACACA;
    color:#666666;
}

  .success-lead-form button {
    color: #000;
    font-family: "DM Sans", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: normal;
    text-align: center;
    background: #1EE576;
    padding: 18px 80px;
    border-radius: 100px;
    border: none;
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .success-lead-form button:focus-visible,
  .lead-form button:focus-visible {
    outline: none;
  }
  
  .lead-form button:hover,
  .success-lead-form button:hover {
    background-color: #00B140;
  }
  
    @media screen and (max-width: 767px) {
    #leadSuccessModal button#btnDone {
        width: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
        #leadSuccessModal .modal-dialog {
        max-width: 390px;
        margin: 0 16px !important;
    }
    #leadSuccessModal .modal-content {
        padding: 0;
    }
    #leadSuccessModal .modal-body .donexx p{
        margin: 0;
    }
    #leadSuccessModal .modal-content .modal-header {
        padding: 24px 24px 0 !important;
    }

    #leadSuccessModal .modal-content .modal-body {
        padding: 16px 24px 32px;
    }

    #leadSuccessModal .modal-content .modal-body .donexx {
        margin-bottom: 32px;
    }

    #leadSuccessModal .modal-header .modal-title.donex{
        font-size: 36px !important;
        line-height: 38.52px !important;
    }

    #leadSuccessModal .modal-title.donex {
    margin-top: 40px;
    }
  }
/**Success modal**/`, "",{"version":3,"sources":["webpack://./src/styles/userDetails/userDetails.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,4CAA4C;EAC5C,wBAAwB;EACxB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,qCAAqC,EAAE,sBAAsB;EAC7D,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,+CAA+C;EAC/C,2CAA2C;EAC3C,uBAAuB,EAAE,sCAAsC;AACjE;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,mDAAmD;EACnD,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB,EAAE,wDAAwD;AAC7E;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc,EAAE,iCAAiC;EACjD,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,kBAAkB;IAClB,eAAe;EACjB;EACA;;IAEE,mBAAmB;EACrB;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,wBAAwB;IACxB,YAAY;IACZ,WAAW;IACX,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;AACA,gBAAgB;;AAEhB,8BAA8B;;AAE9B;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,MAAM;EACN,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,aAAa;AACf;AACA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;;EAGE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;AAC7B;;;AAGA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB;AACF;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,oCAAoC;AACxC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,kDAAkD;EAClD,iBAAiB;EACjB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;;GAEG,wBAAwB;IACvB,mBAAmB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;AACA;;;EAGE,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,MAAM;EACN,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,6BAA4B;EAK5B;AAJF;;AAOA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB;AACF;;AAEA;EAGE,kCAAkC;EAGlC;AACF;;AAEA;EAEE;AACF;;AAEA;EAEE,aAAa;EAEb,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAElB,aAAa;EAGb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EAEE,aAAa;EAEb,uBAAuB;EAEvB,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;EAChC,yBAAyB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAElB,cAAc;EACd;AACF;;AAEA;EAEE,aAAa;EAEb,mBAAmB;EAEnB,yBAAyB;EACzB,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;AACA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;;EAEE;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,kCAAkC;IAClC,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,0BAA0B;EAC1B,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA,8BAA8B;;AAE9B,kBAAkB;AAClB;IACI,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,SAAS;IACT,aAAa;IACb,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;;AAGA,mCAAmC;;;AAGnC;IACI,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,UAAU;AACd;;EAEE;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,UAAU;EACZ;;EAEA;;IAEE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;IAEE;IACA,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IAInB,oBAAoB;AAHxB;;AAMA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;EAEE;IACE,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,yBAAyB;EAC3B;;IAEE;IACA;QACI,WAAW;IACf;EACF;;EAEA;QACM;QACA,gBAAgB;QAChB,yBAAyB;IAC7B;IACA;QACI,UAAU;IACd;IACA;QACI,SAAS;IACb;IACA;QACI,+BAA+B;IACnC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,+BAA+B;IACnC;;IAEA;IACA,gBAAgB;IAChB;EACF;AACF,kBAAkB","sourcesContent":[".submitBtn {\n  color: #000000 !important;\n  font-family: \"DM Sans\", sans-serif !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 22px !important;\n  letter-spacing: normal !important;\n  text-align: center !important;\n  background: rgba(30, 229, 118, 1) !important;\n  padding: 16px !important;\n  border-radius: 100px !important;\n  border: none !important;\n  cursor: pointer !important;\n  margin-top: 0;\n}\n\n:root {\n  --accent-green: rgba(30, 229, 118, 1); /* same as submitBtn */\n  --text-dark: #000000;\n  --table-bg: #ffffff;\n  --table-header-bg: #046A38;\n  --table-header-border: rgba(30, 229, 118, 0.30);\n  --table-row-hover: rgba(30, 229, 118, 0.08);\n  --table-border: #e9ecef; /* close to Bootstrap's border color */\n}\n\n.table-theme {\n  font-family: \"DM Sans\", sans-serif;\n  color: var(--text-dark);\n}\n\n.table-theme .table-card {\n  background: var(--table-bg);\n  border: 1px solid var(--table-border);\n  border-radius: 16px;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.06);\n}\n\n.table-theme .table {\n  margin: 0;\n  border-collapse: separate;       \n  border-spacing: 0;\n}\n\n.table-theme .table thead tr:first-child th:first-child {\n  border-top-left-radius: 16px;\n}\n.table-theme .table thead tr:first-child th:last-child {\n  border-top-right-radius: 16px;\n}\n.table-theme .table tbody tr:last-child td:first-child {\n  border-bottom-left-radius: 16px;\n}\n.table-theme .table tbody tr:last-child td:last-child {\n  border-bottom-right-radius: 16px;\n}\n\n.table-theme .table thead th {\n  background: var(--table-header-bg);\n  border-bottom: 2px solid var(--table-header-border);\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 22px;\n  letter-spacing: 0.2px;\n  text-transform: none;\n}\n\n.table-theme .table tbody td,\n.table-theme .table thead th {\n  padding: 8px 16px; /* visually aligned with your button’s comfort spacing */\n}\n\n.table-theme .table tbody tr:hover {\n  background: var(--table-row-hover);\n}\n\n.table-theme .table tbody tr + tr td {\n  border-top: 1px solid var(--table-border);\n}\n\n.table-theme .table tbody td.id-col {\n  color: var(--text-dark);\n  font-weight: 500;\n}\n\n.table-theme .badge-accent {\n  display: inline-block;\n  border-radius: 999px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #0f7a4d; /* readable on light background */\n  background: rgba(30, 229, 118, 0.18);\n  border: 1px solid rgba(30, 229, 118, 0.35);\n}\n\n.table-theme .btn-outline-accent {\n  color: var(--text-dark);\n  border-radius: 100px;\n  border: 1px solid rgba(0,0,0,0.12);\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: 500;\n  background: #fff;\n}\n.table-theme .btn-outline-accent:hover {\n  border-color: rgba(30, 229, 118, 0.8);\n  color: #0f7a4d;\n  background: rgba(30, 229, 118, 0.08);\n}\n\n.table-theme .btn-accent {\n  color: var(--text-dark) !important;\n  font-family: \"DM Sans\", sans-serif !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 22px !important;\n  text-align: center !important;\n  background: var(--accent-green) !important;\n  padding: 10px 18px;                \n  border-radius: 100px !important;\n  border: none !important;\n  cursor: pointer !important;\n}\n\n@media (max-width: 576px) {\n  .table-theme .table thead th,\n  .table-theme .table tbody td {\n    padding: 12px 12px;\n    font-size: 13px;\n  }\n  .table-theme .table thead th:last-child,\n  .table-theme .table tbody td:last-child {\n    white-space: nowrap;\n  }\n}\n\n/**Pagination **/\n.pagination {\n  display: flex;\n  gap: 5px;\n  justify-content: center;\n  align-items: center;\n  margin-top: 15px;\n  /* padding-bottom: 60px; */\n}\n\n.page-btn {\n    border: 1px solid #222;\n    padding: 6px 12px;\n    border-radius: 50%;\n    cursor: pointer;\n    background-color: #fff;\n    color: #222222;\n    transition: all .2s ease;\n    height: 44px;\n    width: 44px;\n    font-family: var(--INTER-FONT);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    margin-top: inherit;\n}\n\n.page-btn.active {\n  background-color: #222;\n  color: white;\n  border-color: #222;\n}\n\n.next-btn {\n  font-weight: 700;\n  font-size: 16px;\n  padding: 6px 10px;\n  border: none;\n}\n/**Pagination **/\n\n/**Common add/edit modal css**/\n\n.modal {\n  display: none;\n  /* Hidden by default */\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  padding-top: 100px;\n  /* Location of the box */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: rgb(0, 0, 0);\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */\n}\ndiv.userDetailsModal {\n  padding: 0 !important;\n  z-index: 9999;\n}\n/* Modal Content */\n.modal-content {\n  background-color: #fefefe;\n  margin: auto;\n  padding: 0;\n  border: 1px solid #888;\n}\n\nbody.modal-open {\n  padding: 0 !important;\n}\n.lead-form .form-label {\n  margin: 16px 0 0 0;\n}\n\n.lead-form label {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: normal;\n  text-align: left;\n  color: rgba(102, 102, 102, 1);\n}\n\n.lead-form input[type=\"text\"],\n.lead-form input[type=\"email\"],\n.lead-form input[type=\"number\"] {\n  border-left: none;\n  border-right: none;\n  outline: none;\n  border-radius: 0;\n  border-top: none;\n  padding: 5px 0;\n  box-shadow: unset;\n}\n\n.passwordInputs {\n  border-bottom: 1px solid #8C8C8C !important;\n  border-left: none !important;\n  border-right: none !important;\n  border-top: none !important;\n  border-radius: 0 !important;\n}\n\n\n.branchSelect {\n  min-height: 35px ;\n  cursor: pointer;\n}\n\n.list-group-item {\n  padding: 4px 10px !important;\n}\n.userDetailsModal .modal-body p:nth-child(2) {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px !important;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: normal;\n  color: #000000;\n}\n\n.userDetailsModal .modal-body p:nth-child(1) span {\n  font-family: \"Inter\", sans-serif;\n  letter-spacing: normal;\n  font-size: 12px;\n  color: #666;\n  font-weight: 400;\n  line-height: 18px\n}\n\n.userDetailsModal form.userDetailsModal .row.mt-4:has(.col-md-1) {\n  margin-top: 16px !important;\n  align-items: center !important;\n}\n\n.userDetailsModal label {\n  font-family: \"Inter\", sans-serif !important;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: normal;\n  text-align: left;\n  color: #222222 !important;\n  display: inline-block;\n}\n\n.userDetailsModal .form-control {\n  padding: 0 !important;\n  border-bottom-color: #8C8C8C;\n}\n\n#editUserModal .submitBtn:focus {\n    outline: 2px solid #222 !important;\n    outline-offset: 0px;\n    background-color: #00b140 !important;\n}\n#addUserModal .submitBtn:focus {\n    outline: 2px solid #222 !important;\n    outline-offset: 0px;\n    background-color: #00b140 !important;\n}\n#loading-image{\n  color: #000000;\n}\n\n.lead-form button {\n  color: #000000 !important;\n  font-family: \"DM Sans\", sans-serif !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 22px !important;\n  letter-spacing: normal !important;\n  text-align: center !important;\n  /* background: rgba(30, 229, 118, 1) !important; */\n  padding: 16px 35%;\n  border-radius: 100px !important;\n  border: none !important;\n  cursor: pointer !important;\n  margin-top: 0;\n}\n\n.userDetailsModal .modal-body p span {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  line-height: 19.6px;\n  color: #414141;\n  font-weight: 400;\n  text-align: left;\n  letter-spacing: normal;\n}\n\n.userDetailsModal .btn-close {\n  position: absolute;\n  right: 32px;\n  top: 32px;\n  width: 35px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  cursor: pointer;\n  background: none;\n  opacity: 1;\n  border: 0;\n}\n.userDetailsModal .btn-close:focus,\n.userDetailsModal .btn-close:focus-visible {\n   outline: 2px solid black;\n    outline-offset: 2px;\n}\n\n.userDetailsModal .btn-close:before,\n.userDetailsModal .btn-close:after {\n  position: absolute;\n  top: 0;\n  content: ' ';\n  height: 24px;\n  width: 3px;\n  background-color: #333;\n  display: inline-block;\n}\n\n.userDetailsModal .btn-close:before {\n  transform: rotate(45deg);\n}\n\n.userDetailsModal .btn-close:after {\n  transform: rotate(-45deg);\n}\n\n.userDetailsModal .modal-header {\n  border-bottom: 0;\n  padding: 54px 56px 0 56px;\n  padding: 0;\n}\n\n.userDetailsModal .modal-body {\n  max-height: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-left: 5px;\n}\n\n/* MultiSelect Dropdown Styles */\n.tg-multiselect {\n  position: relative !important;\n  z-index: 1000 !important;\n}\n\n.userDetailsModal .tg-multiselect {\n  z-index: 1001 !important;\n}\n\n.tg-multiselect-panel {\n  z-index: 10000 !important;\n  max-width: 90vw !important;\n}\n\n/* Ensure modal body doesn't clip the dropdown */\n.userDetailsModal .modal-dialog {\n  overflow: visible !important;\n}\n\n.userDetailsModal .modal-content {\n  overflow: visible !important;\n}\n\n.userDetailsModal .modal-body {\n  overflow: visible !important;\n  position: relative;\n  z-index: auto;\n}\n\n/* Responsive styles for MultiSelect */\n@media (max-width: 576px) {\n  .tg-multiselect-panel {\n    max-width: 85vw !important;\n    max-height: 250px !important;\n  }\n  \n  .userDetailsModal .col-md-6 {\n    position: relative;\n    z-index: 1001;\n  }\n}\n\n@media (min-width: 577px) and (max-width: 768px) {\n  .tg-multiselect-panel {\n    max-width: 80vw !important;\n    max-height: 300px !important;\n  }\n}\n\n@media (min-width: 769px) {\n  .tg-multiselect-panel {\n    max-width: auto !important;\n    max-height: 400px !important;\n  }\n}\n.lead-form input[type=\"text\"],\n.lead-form input[type=\"email\"],\n.lead-form input[type=\"number\"] {\n  min-height: 35px !important;\n}\n\n/* width */\n.userDetailsModal::-webkit-scrollbar {\n  width: 2px;\n}\n\n/* Track */\n.userDetailsModal ::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n.userDetailsModal ::-webkit-scrollbar-thumb {\n  background: #414141;\n}\n\n/* Handle on hover */\n.userDetailsModal ::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.userDetailsModal .modal-title {\n  font-family: \"DM Sans\",sans-serif;\n  font-size: 48px;\n  font-weight: 500;\n  line-height: 52.8px;\n  letter-spacing: normal;\n  text-align: left;\n  color: #222222;\n}\n\n.userDetailsModal span#myModalClose {\n  border-radius: 0;\n  padding: 0 !important;\n  margin-right: 10px !important;\n}\n\n.userDetailsModal.show{\n  display: block !important;\n}\n\n/* width */\n.userDetailsModal ::-webkit-scrollbar {\n  width: 2px;\n}\n\n/* Track */\n.userDetailsModal ::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n.userDetailsModal ::-webkit-scrollbar-thumb {\n  background: #414141;\n}\n\n/* Handle on hover */\n.userDetailsModal ::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.modal {\n  display: none;\n  /* Hidden by default */\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  padding-top: unset;\n  /* Location of the box */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: rgb(0, 0, 0);\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */\n}\n\n/* Modal Content */\n.modal-content {\n  background-color: #fefefe;\n  margin: auto;\n  padding: 0;\n  border: 1px solid #888;\n}\n\n.modal-backdrop {\n  display: none;\n}\n\n.modal,\n.modal-open {\n  background: rgba(0, 0, 0, .5)\n}\n\n.modal,\n.modal-open {\n  overflow: hidden\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  outline: 0\n}\n\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 8px !important;\n  pointer-events: none\n}\n\n.modal.fade .modal-dialog {\n  transition: -webkit-transform .3s ease-out;\n  -webkit-transition: -webkit-transform .3s ease-out;\n  transition: transform .3s ease-out;\n  transition: transform .3s ease-out, -webkit-transform .3s ease-out;\n  -webkit-transform: translateY(-25%);\n  transform: translateY(-25%)\n}\n\n.modal.show .modal-dialog {\n  -webkit-transform: translate(0);\n  transform: translate(0)\n}\n\n.modal-dialog-centered {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  min-height: calc(100% - 16px)\n}\n\n.modal-content {\n  position: relative;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(28, 28, 28, .2);\n  border-radius: 16px;\n  outline: 0\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #1c1c1c\n}\n\n.modal-backdrop.fade {\n  opacity: 0\n}\n\n.modal-backdrop.show {\n  opacity: .5\n}\n\n.modal-header {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: justify;\n  justify-content: space-between;\n  padding: 16px;\n  border-bottom: 1px solid #e9ecef;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.55\n}\n\n.modal-body {\n  position: relative;\n  -webkit-box-flex: 1;\n  flex: 1 1 auto;\n  padding: 16px\n}\n\n.modal-footer {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  justify-content: flex-end;\n  padding: 16px;\n  border-top: 1px solid #e9ecef\n}\n\n.modal-footer>:not(:first-child) {\n  margin-left: .25rem\n}\n\n.modal-footer>:not(:last-child) {\n  margin-right: .25rem\n}\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll\n}\n\n.modal-content .modal-body_title {\n  color: #00703c;\n  font-size: 36px\n}\n\n.modal-header {\n  border-bottom: none\n}\n\n.modal-body {\n  padding: 44px 16px 100px\n}\n\n.modal-section-padding {\n  padding-right: 17px\n}\n.userDetailsModal .submitBtn{\n  height: auto;\n}\n\n.userDetailsModal .submitBtn:hover, #editUserModal .submitBtn:focus {\n  background-color: #00B140 !important;\n}\n.userDetailsModal .modal-content{\n  padding: 64px 56px 56px;\n  border-radius: 16px;\n}\n\n.invalid-feedback.show {\n  display: block !important;\n}\n\n@media screen and (max-width: 600px) {\n  .lead-form button#submit_lead_data {\n    margin-top: 4px !important;\n    padding: 13px 0px;\n    width: 100%;\n  }\n}\n\n@media (min-width:576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 28px auto !important;\n    padding: 0;\n  }\n\n  .modal-dialog-centered {\n    min-height: calc(100% - 56px)\n  }\n\n  .modal-sm {\n    max-width: 300px\n  }\n}\n\n@media (max-width: 767px) {\n\n  .userDetailsModal .modal-title {\n    font-size: 36px !important;\n    line-height: 38.52px !important;\n  }\n  .userDetailsModal .modal-content .modal-header{\n    padding: 24px 16px 16px;\n  }\n  .userDetailsModal .modal-body {\n    padding: 0 16px 16px;\n  }\n  .userDetailsModal .call-now-mob.d-block {\n    background: #000;\n    color: #fff !important;\n    width: 100%;\n    display: block !important;\n    padding: 16px 0;\n    border-radius: 40px;\n    text-align: center;\n    text-decoration: none;\n    margin-bottom: 26px;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 22px;\n    text-transform: capitalize;\n    font-family: \"DM Sans\", sans-serif;\n    letter-spacing: normal;\n  }\n  .userDetailsModal .submitBtn {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .userDetailsModal .modal-content{\n    padding: 64px 16px 32px;\n  }\n}\n\n@media (min-width:720px) and (max-width:766px) {\n  button#submit_lead_data {\n    width: 100%;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .userDetailsModal .modal-dialog {\n    max-width: 800px !important;\n  }\n}\n\n@media (min-width:720px) and (max-width:766px) {\n  .userDetailsModal .modal-dialog {\n    max-width: 500px !important;\n  }\n}\n\n@media (min-width:768px) and (max-width:991px) {\n  .userDetailsModal .modal-dialog {\n    max-width: 700px;\n  }\n\n  .userDetailsModal .show {\n    display: block !important;\n  }\n}\n\n\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .userDetailsModal .modal-content {\n    width: 100% !important;\n  }\n\n  .userDetailsModal .modal-title {\n    font-size: 48px !important;\n  }\n}\n\n.invalid-feedback{\n  color: #D22B2B !important;\n  width: 100%;\n  margin-top: 4px !important;\n  font-size: 12px !important;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  line-height: 18px;\n}\n.userDetailsModal .btn-close:focus{\n  outline: 2px solid transparent !important;\n  box-shadow: none !important;\n}\n\n/**Common add/edit modal css**/\n\n/**Success modal**/\n#leadSuccessModal {\n    background: rgba(0, 0, 0, .5);\n}\n\n#leadSuccessModal.show {\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n    z-index: 10000;\n}\n\n#leadSuccessModal .modal-dialog {\n    width: 100%;\n    max-width: 800px;\n    margin: 0 16px !important;\n}\n\n#leadSuccessModal .modal-dialog button.btn-close {\n    align-self: flex-start;\n    position: absolute;\n    right: 24px;\n    top: 24px;\n    margin: 0;\n    padding: 11px;\n    opacity: 1;\n}\n\n#leadSuccessModal .modal-dialog .modal-content{\n    border: none;\n    border-radius: 16px;\n}\n\n#leadSuccessModal .modal-body .donexx p {\n    font-family: \"Inter\",sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n}\n\n\n/* css for lead and success modal */\n\n\n#leadSuccessModal .modal-header {\n    padding: 24px 56px 0 40px !important;\n    padding: 0 !important;\n}\n  \n#leadSuccessModal .modal-body {\n    padding: 24px 30px 48px 40px;\n    padding: 0;\n}\n  \n#leadSuccessModal .modal-dialog.modal-lg {\n    height: 100%;\n    align-items: center;\n    display: flex;\n    margin-top: 0;\n    padding: 0;\n}\n\n  #leadSuccessModal .btn-close {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    width: 20px;\n    height: 20px;\n    display: block;\n    cursor: pointer;\n    background: transparent;\n    border: none;\n    padding: 0;\n  }\n  \n  #leadSuccessModal .btn-close:before,\n  #leadSuccessModal .btn-close:after {\n    position: absolute;\n    content: ' ';\n    height: 20px;\n    width: 2px;\n    background-color: #333;\n    top: 0;\n  }\n  \n  #leadSuccessModal .btn-close:before {\n    transform: rotate(45deg);\n  }\n  \n  #leadSuccessModal .btn-close:after {\n    transform: rotate(-45deg);\n  }\n\n    #leadSuccessModal .modal-title {\n    font-family: \"DM Sans\",sans-serif;\n    font-size: 48px;\n    font-weight: 500;\n    line-height: 52.8px;\n    letter-spacing: normal;\n    text-align: left;\n    color: #222222;\n  }\n  #leadSuccessModal .modal-body p {\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #414141;\n    margin-bottom: 24px;\n    margin-top: 16px;\n  }\n  \n  #leadSuccessModal form.success-lead-form {\n    /* margin-top: 81px; */\n  }\n  \n  #leadSuccessModal #btnTrigger{\n    display: none;\n  }\n  #leadSuccessModal .modal-content{\n    border-radius: 16px;\n    padding: 64px 56px 56px;\n    border: none;\n  }\n  \n  #leadSuccessModal .modal-body {\n    max-height: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    margin-right: 5px;\n    /* padding: 16px 56px 40px; */\n  }\n\n  #leadSuccessModal .modal-title.donex {\n    font-family: \"DM Sans\",sans-serif;\n    font-size: 48px;\n    font-weight: 500;\n    line-height: 52.8px;\n    letter-spacing: normal;\n    text-align: left;\n    /* margin-top:40px; */\n}\n\n#leadSuccessModal .modal-header {\n    border-bottom: none;\n}\n\n#leadSuccessModal .modal-header{\n    padding: 24px 56px 0;\n}\n\n#btnDone {\n    background-color: #1EE576;\n    color: #000000;\n    width: 214px;\n    height: 48px !important;\n    border-radius: 40px;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n#leadForm .submitBtn:hover, #leadSuccessForm #btnDone:hover {\n    background-color: #19C063;\n}\n\n#leadForm .submitBtn:focus, #leadSuccessForm #btnDone:focus {\n    background-color: #19C063 !important;\n    outline: none;\n}\n\n#leadForm .submitBtn:disabled, #leadSuccessForm #btnDone:disabled {\n    background-color: #CACACA;\n    color:#666666;\n}\n\n  .success-lead-form button {\n    color: #000;\n    font-family: \"DM Sans\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 22px;\n    letter-spacing: normal;\n    text-align: center;\n    background: #1EE576;\n    padding: 18px 80px;\n    border-radius: 100px;\n    border: none;\n    cursor: pointer;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .success-lead-form button:focus-visible,\n  .lead-form button:focus-visible {\n    outline: none;\n  }\n  \n  .lead-form button:hover,\n  .success-lead-form button:hover {\n    background-color: #00B140;\n  }\n  \n    @media screen and (max-width: 767px) {\n    #leadSuccessModal button#btnDone {\n        width: 100%;\n    }\n  }\n\n  @media only screen and (max-width: 600px) {\n        #leadSuccessModal .modal-dialog {\n        max-width: 390px;\n        margin: 0 16px !important;\n    }\n    #leadSuccessModal .modal-content {\n        padding: 0;\n    }\n    #leadSuccessModal .modal-body .donexx p{\n        margin: 0;\n    }\n    #leadSuccessModal .modal-content .modal-header {\n        padding: 24px 24px 0 !important;\n    }\n\n    #leadSuccessModal .modal-content .modal-body {\n        padding: 16px 24px 32px;\n    }\n\n    #leadSuccessModal .modal-content .modal-body .donexx {\n        margin-bottom: 32px;\n    }\n\n    #leadSuccessModal .modal-header .modal-title.donex{\n        font-size: 36px !important;\n        line-height: 38.52px !important;\n    }\n\n    #leadSuccessModal .modal-title.donex {\n    margin-top: 40px;\n    }\n  }\n/**Success modal**/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
